import {DashboardTileId} from '../types/DashboardTileId';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {applyDashboardGridLayout} from './applyDashboardGridLayout';
import {reconcileDashboardGrid} from './reconcileDashboardGrid';

export function positionVisibleDashboardTiles(
  placements: DashboardTilePlacement[],
  visibleIds: DashboardTileId[]
): DashboardTilePlacement[] {
  const visibleIdSet = new Set(visibleIds);
  const visiblePlacements = placements.filter((placement) => visibleIdSet.has(placement.id));

  return applyDashboardGridLayout(placements, reconcileDashboardGrid(visiblePlacements));
}
